import type { ReactNode } from 'react'
import { cx } from '@/ui'

/**
 * Yüzey bileşenleri.
 *
 * <p>Arayüzün derinliği renkten değil katmandan geliyor: gri zemin → beyaz
 * yüzey → ince çizgi. Bu parçalar o katmanı her ekranda aynı şekilde kurar;
 * tek tek kart/kenarlık kararı verilmesin diye.
 */

/** Başlıklı panel (tasarımdaki 18px başlıklı, 24px iç boşluklu kart). */
export function SectionCard({
  title, description, actions, children, padding, className, id, headingLevel = 2,
}: {
  title?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  children: ReactNode
  /** Gövdenin iç boşluğu. Liste panellerinde satırlar kendi boşluğunu taşır. */
  padding?: number | string
  className?: string
  id?: string
  headingLevel?: 2 | 3
}) {
  const H = headingLevel === 3 ? 'h3' : 'h2'
  return (
    <section className={cx('nx-panel', 'nx-section', className)} aria-labelledby={title && id ? `${id}-h` : undefined}>
      {(title || actions) && (
        <div className="nx-section__head">
          <div className="nx-section__titles">
            {title && <H id={id ? `${id}-h` : undefined} className="nx-section__title">{title}</H>}
            {description && <span className="nx-section__desc">{description}</span>}
          </div>
          {actions && <div className="nx-section__actions">{actions}</div>}
        </div>
      )}
      <div className="nx-section__body" style={padding !== undefined ? { padding } : undefined}>{children}</div>
    </section>
  )
}

/** Tek bir sayıyı öne çıkaran kart. {@code dark} tasarımdaki mürekkep "Son 7 gün" kartı. */
export function StatTile({
  label, value, hint, icon, dark, aside, className,
}: {
  label: string
  value: ReactNode
  hint?: ReactNode
  icon?: ReactNode
  dark?: boolean
  /** Değerin sağında duran küçük görsel (mini grafik). */
  aside?: ReactNode
  className?: string
}) {
  return (
    <div className={cx('nx-stat', dark && 'nx-stat--dark', className)}>
      <div className="nx-stat__head">
        <span className="nx-stat__label">{label}</span>
        {icon && <span className="nx-stat__icon" aria-hidden="true">{icon}</span>}
      </div>
      <div className="nx-stat__row">
        <span className="nx-stat__value nx-nums">{value}</span>
        {aside}
      </div>
      {hint && <div className="nx-stat__hint">{hint}</div>}
    </div>
  )
}

/** Bölüm ayıracı: çizgi değil, büyük harf bir etiket. */
export function SectionLabel({ children, mt }: { children: ReactNode; mt?: number | string }) {
  return <div className="nx-eyebrow" style={mt !== undefined ? { marginTop: mt } : undefined}>{children}</div>
}
